import useMeetingReport from "@app/analytics/MeetingReport/hooks/useMeetingReport";
import useSessionMetadata from "@app/analytics/MeetingReport/hooks/useSessionMetadata";
import type { MeetingReportRecapChartsProps } from "@app/analytics/MeetingReport/MeetingReportContent/MeetingReportRecapContent/MeetingReportRecapCharts";

interface UseRecapChartsReturn extends MeetingReportRecapChartsProps {
  showCharts: boolean;
}

const useRecapCharts = (): UseRecapChartsReturn => {
  const {
    data: {
      isNotetakerReport,
      isUploadedSession,
      tier,
      tierDescription,
      metricsLevel,
    },
  } = useSessionMetadata();

  const sessionMayHaveAffectiveMetrics = !(
    isUploadedSession || isNotetakerReport
  );

  const { meetingReport } = useMeetingReport({
    enabled: sessionMayHaveAffectiveMetrics,
  });

  const showCharts =
    sessionMayHaveAffectiveMetrics &&
    meetingReport?.engagement != null &&
    metricsLevel !== "objective_metrics";

  return {
    showCharts,
    tier,
    tierDescription,
    meetingScore: {
      overall: Math.round(meetingReport?.callScore ?? 0),
      trend: meetingReport?.callScoreTrend ?? [],
    },
    engagement: {
      overall: Math.round(meetingReport?.engagement ?? 0),
      trend: meetingReport?.engagementTrend ?? [],
    },
    sentiment: {
      overall: Math.round(meetingReport?.sentiment ?? 0),
      trend: meetingReport?.sentimentTrend ?? [],
    },
  };
};

export default useRecapCharts;
